<template>
  <a @click="open = !open">
    CART({{ data.item_count }})
  </a>
</template>

<script>
import store from '../store';

export default {
  name: "Cart",
  selector: "#vue-cart",
  store,
  computed: {
    data() {
      return this.$store.getters['cart/data'];
    },
    open: {
      get() {
        return this.$store.getters['cart/open'];
      },
      set(open) {
        this.$store.commit('cart/open', open);
      }
    }
  }
}
</script>
